module.exports = __webpack_public_path__ + "static/media/himanshu-profile.ce99ab61.jpg";